import React, {useState, FC} from "react";
import {useTranslation} from "next-i18next";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import {ProfileForm} from "../onboarding/profile-form";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import useWidth from "../../hooks/use-width";
import {TransitionProps} from "@mui/material/transitions";
import {LoadingButton} from "@mui/lab";
import {OnboardingChildRefInterface} from "../onboarding/onboarding";


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction='up' ref={ref} {...props} />;
});

interface ProfileUpdateDialogProps {
    open: boolean
    onFinished: () => void,
}

export const ProfileUpdateDialog: FC<ProfileUpdateDialogProps> = ({onFinished, open}) => {

    const width = useWidth()

    const fullScreen = width == "xs"

    const {t} = useTranslation();

    const profileFormRef = React.useRef<OnboardingChildRefInterface>(null);


    const [submitting, setSubmitting] = useState<boolean>(false);

    const advanceToNextStep = () => {
        setSubmitting(false);
        //dispatch(fetchUserProfile(embeddedProfile.uid));
        onFinished();
    };

    const showProgress = (shouldShow: boolean) => {
        setSubmitting(shouldShow);
    };


    const handleSubmit = (e: any) => {
        setSubmitting(true);
        profileFormRef.current?.submitStep();
    };

    return (
        <Dialog

            fullScreen={fullScreen}
            open={open}
            onClose={(e, reason) => {
                onFinished();
            }}
            TransitionComponent={Transition}
            maxWidth={"md"}
        >
            <DialogContent sx={{pl: 1}}>

                <ProfileForm
                    ref={profileFormRef}
                    advanceParentToNextStep={advanceToNextStep}
                    showParentProgress={showProgress}
                />

            </DialogContent>
            <DialogActions>
                <LoadingButton
                    loading={submitting}
                    onClick={handleSubmit}
                    color='primary'
                    variant='contained'
                    autoFocus
                >
                    {t("save")}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}


